import {
    HotelFeatureGPSIcon,
    HotelFeatureRepairIcon,
    HotelFeatureParkIcon,
    HotelFeatureRentIcon,
    HotelFeatureLoadingIcon,
    HotelFeatureToolsIcon,
    HotelFeatureMapIcon,
} from '../config/icons';

export default function getIconForFeature(key: string) {
    switch (key) {
        case 'gps':
            return HotelFeatureGPSIcon;
        case 'loading':
            return HotelFeatureLoadingIcon;
        case 'map':
            return HotelFeatureMapIcon;
        case 'park':
            return HotelFeatureParkIcon;
        case 'rent':
            return HotelFeatureRentIcon;
        case 'repair':
            return HotelFeatureRepairIcon;
        case 'tools':
            return HotelFeatureToolsIcon;

        default:
            return null;
    }
}
